module.exports = __webpack_public_path__ + "img/3.c2ee9685.webp";